module.exports = __webpack_public_path__ + "./docs/img/close-fullscreen-image.8c1d7876ba1e8233a5954b89d4398553.svg";